module.exports = __webpack_public_path__ + "img/simulated_single_bidding.d3f9889c.png";